import { gql } from '@apollo/client';

const PAYMENT_METHODS_FRAGMENT = gql`
  fragment PaymentMethods on Magento2_Cart {
    selectedPaymentMethod {
      code
    }
    availablePaymentMethods {
      code
      title
    }
  }
`;

export const PAYMENT_METHODS_QUERY = gql`
  ${PAYMENT_METHODS_FRAGMENT}

  query PaymentMethodsQuery($storeCode: String!, $isVirtualCart: Boolean!) {
    magento2 {
      customer {
        nativeId
        globalOrders(
          filter: { website: $storeCode, is_virtual: $isVirtualCart }
          pageSize: 1
        ) {
          items {
            id
            paymentMethods {
              type
            }
          }
        }
      }
      customerCart {
        id
        ...PaymentMethods
      }
    }
  }
`;

export const SET_PAYMENT_METHOD_MUTATION = gql`
  ${PAYMENT_METHODS_FRAGMENT}

  mutation SetPaymentMethodMutation($cartId: String!, $code: String!) {
    magento2 {
      setPaymentMethodOnCart(
        input: { cart_id: $cartId, payment_method: { code: $code } }
      ) {
        cart {
          id
          ...PaymentMethods
        }
      }
    }
  }
`;

export const PLACE_ORDER_MUTATION = gql`
  mutation PlaceOrderMutation(
    $cartId: String!
    $returnUrl: String!
    $successUrl: String!
    $failedUrl: String!
    $origin: String!
  ) {
    magento2 {
      redirectAndPlaceOrder(
        input: {
          cart_id: $cartId
          return_url: $returnUrl
          success_url: $successUrl
          failed_url: $failedUrl
          origin: $origin
        }
      ) {
        payRedirectUrl
      }
    }
  }
`;

gql`
  query CheckPlaceOrderStatus($cartId: String!) {
    magento2 {
      checkPlaceOrderStatus(cart_id: $cartId) {
        orderIncrementId
        orderStatus
        errors
      }
    }
  }
`;
